import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../../services/authService';
import { trackEvent } from '../../config/googleAnalytics';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userName = localStorage.getItem('userName');
  const userPhoto = localStorage.getItem('userPhoto');
  const isOnChatPage = location.pathname === '/chat';

  const handleLogout = async () => {
    try {
      // Track logout event
      trackEvent('User', 'Logout', userName);
      
      await authService.logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header className="header">
      <div 
        className="logo" 
        onClick={() => {
          trackEvent('Navigation', 'Click Logo', 'Header');
          navigate('/');
        }}
      >
        RizzologyGPT
      </div>
      {authService.isAuthenticated() && isOnChatPage && (
        <div className="user-section">
          <div className="user-info">
            {userPhoto && (
              <img 
                src={userPhoto} 
                alt={userName} 
                className="user-photo"
              />
            )}
            <span className="user-name">{userName}</span>
          </div>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      )}
    </header>
  );
};

export default Header; 